import { render, staticRenderFns } from "./Institutional.vue?vue&type=template&id=de1edce0"
import script from "./Institutional.vue?vue&type=script&lang=js"
export * from "./Institutional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports